import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/visitorLogin'
    },
    {
      path: '/visitorLogin',
      component: resolve => require(['../page/visitor/visitorLogin/index.vue'], resolve)
    },
    {
      path: '/visitorAppointment',
      component: resolve => require(['../page/visitor/visitorAppointment/index.vue'], resolve)
    },
    {
      path: '*',
      redirect: '/visitorLogin'
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js